import { ContactSupport } from "@mui/icons-material";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { waUrlBuilder } from "./utils/waSupportBuilder";
import { SupportButton } from "../../../components/Button/SupportButton/SupportButton";

export interface ICallSuportComponent {}

export function CallSuportComponent({}: ICallSuportComponent) {

    const { t } = useTranslation();
    
    return (
        <Grid item xs={12} marginTop="18px">
            <Box
                width="100%"
                borderRadius="4px"
                border="1px solid #0000001A"
                height="56px"
                display="flex"
                justifyContent="space-between"
                padding={1}
                alignItems="center"
            >
                <Box
                    gap={2}
                    display="flex"
                >
                    <ContactSupport 
                        fontSize="large"
                        sx={{
                            color: "#22638D"
                        }}
                    />
                    <Box
                        display="flex"
                        alignItems="center"
                    >
                        <Typography
                            fontSize="14px"
                            width="200px"
                            fontWeight="600"
                        >
                            {t("MyData.ContantSup")}
                        </Typography>
                    </Box>
                    <Box
                        display="flex"
                        alignItems="center"
                    >
                        <Typography
                            sx={{
                                opacity: .6
                            }}
                            fontSize="14px"
                        >
                            {t("MyData.ContantTeam")}
                        </Typography>
                    </Box>
                </Box>
                <Box>
                    <SupportButton />
                </Box>
            </Box>
        </Grid>
    )
}